import modalOrg from './view/modalTicketedPoint.html';
import modalSynchro from '../taxControl/view/modalSynchro.html';
import utils from 'utils';
export default class taxControlCtrl {
    constructor($scope, httpRequest, $state, sweetalert, logger, $uibModal, initSortService) {
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                creditCode: '',
                saleName: '',
                diskCode: '',
                manageType: '',
                syncTimeEnd: '',
                syncTimeBegin: '',
            },
        };
        $scope.reset = function () {
            $scope.queryParam.param = {
                creditCode: '',
                saleName: '',
                diskCode: '',
                manageType: '',
                syncTimeEnd: '',
                syncTimeBegin: '',
            };
        };
        // 表头排序
        $scope.orderMap = {};
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {};
            if ($scope.orderMap.sortKey)
                $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal;
            queryList();
        };
        // $scope.reset()
        let downloadUrl = 'ems/sysTaxDisk/exportUkeyInfo?'
        $scope.queryList = function queryList() {
            httpRequest.post_getSysTaxDiskList($scope.queryParam).then(res => {
                $scope.listData = res.data.value.list;
                $scope.totalItems = res.data.value.total;
                downloadUrl = 'ems/sysTaxDisk/exportUkeyInfo?'
                Object.keys($scope.queryParam.param).forEach((key) => {
                    downloadUrl += `${key}=${encodeURI($scope.queryParam.param[key])}&`
                })
            });
        };
        $scope.selectedList = [];
        $scope.asyncHandle = function asyncHandle() {
            if ($scope.selectedList.length == 0) {
                logger.logError('请选择同步数据');
                return;
            }
            let result = [];
            let haveIllegal=false
            $scope.selectedList.forEach(item => {
                let obj = {
                    creditCode: item.creditCode,
                    diskCode: item.diskCode,
                    orgId: item.orgId,
                    serverId: item.serverId,
                };
                haveIllegal=item.manageType!=2
                result.push(obj);
            });
            if(haveIllegal){
                logger.logError('管理方式为服务器托管的才允许进行同步操作，请重新选择');
                return; 
            }
            $scope.sysUkeyFn(result);
        };
        const typecodeArrStr = '["manage_type","server_type","ovat_device_type"]';
        httpRequest.get_dictByTypeArr(typecodeArrStr).then(res => {
            $scope.dictData = res.data.value;
        });
        // 表头排序
        $scope.orderMap = initSortService('taxDiskParam');
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {};
            if ($scope.orderMap.sortKey)
                $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal;
            sessionStorage.setItem('taxDiskParam', JSON.stringify($scope.queryParam));
            $scope.queryList();
        };
        $scope.queryList();
        httpRequest.get_dictByTypeArr(['pack_status']).then(res => {
            $scope.dictionary = res.data.value;
        });
        // 表格下拉框
        $scope.tableDropdownConfig = [
            {
                label: '同步终端信息',
                handler(item) {
                    let param = [
                        {
                            creditCode: item.creditCode,
                            diskCode: item.diskCode,
                            orgId: item.orgId,
                            serverId: item.serverId,
                        },
                    ];
                    $scope.sysUkeyFn(param, true);
                },
                showWhile(item) {
                    return item.manageType==2;
                },
            },
        ];
        $scope.sysUkeyFn = function sysUkeyFn(param, isSingle) {
            utils.loading('正在同步');
            httpRequest.post_sysUkeySyncUkey(param).then(res => {
                if (res.data.success) {
                    // logger.logSuccess('同步成功！')
                    let data=res.data.value
                    let count = 1;
                    let timer = setInterval(() => {
                        count++;
                        if (count > 80) {
                            utils.loaded();
                            clearInterval(timer);
                            timer = null;
                            logger.logError('同步失败！');
                            return;
                        }
                        httpRequest.get_sysServerSyncBatch(data).then(res => {
                            let result = res.data.value;
                            if (result.syncState == 2) {
                                utils.loaded();
                                clearInterval(timer);
                                timer = null;
                                $scope.queryList()
                                if (!result.remark) {
                                    logger.logSuccess('同步终端信息成功，您可以通过开票点管理中查看开票点详情');
                                }else if(isSingle){
                                    let msg=result.remark.split('&&')[1]
                                    msg=msg.replace(/\|/g,'')
                                    logger.logError(msg); 
                                } else {
                                    $uibModal.open({
                                        template: modalSynchro,
                                        controller: [
                                            '$scope',
                                            '$uibModalInstance',
                                            '_props',
                                            function ($scope, $uibModalInstance, _props) {
                                                let { remark, requestNum } = _props.result;
                                                $scope.requestNum = requestNum;
                                                let markArr = remark.split('||');
                                                $scope.listData = [];
                                                let listData = [];
                                                markArr.forEach(item => {
                                                    if (item) {
                                                        let itemArr = item.split('&&');
                                                        let obj = {
                                                            creditCode: itemArr[0],
                                                            reason: itemArr[1],
                                                        };
                                                        listData.push(obj);
                                                    }
                                                });
                                                $scope.listData = listData;
                                                $scope.requestSuccess =
                                                    $scope.requestNum - listData.length;
                                                $scope.cancel = function () {
                                                    $uibModalInstance.dismiss();
                                                };
                                                $scope.ok = function () {
                                                    $uibModalInstance.close();
                                                };
                                            },
                                        ],
                                        backdrop: 'static',
                                        openedClass: 'mod-modal mod-modal-lg',
                                        resolve: {
                                            _props() {
                                                return {
                                                    result,
                                                };
                                            },
                                        },
                                    });
                                }
                            }
                        });
                    }, 1500);
                } else {
                    utils.loaded();
                    logger.logError(res.data.message);
                }
            }).catch(err=>{
                utils.loaded();
            });
        };
        $scope.pointHandle = function pointHandle(item) {
            $uibModal
                .open({
                    template: modalOrg,
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'httpRequest',
                        'logger',
                        '_props',
                        function ($scope, $uibModalInstance, httpRequest, logger, _props) {
                            let param = {
                                orgId: _props.item.orgId,
                                diskId: _props.item.diskId,
                            };
                            $scope.diskName = _props.item.diskName;
                            $scope.diskCode = _props.item.diskCode;
                            $scope.cancel = function () {
                                $uibModalInstance.dismiss();
                            };

                            httpRequest.get_getSysUkeyListByDiskId(param).then(res => {
                                console.log(res);
                                $scope.listData = res.data.value;
                            });
                        },
                    ],
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-lg',
                    resolve: {
                        _props() {
                            return {
                                item,
                            };
                        },
                    },
                })
                .result.then(() => {
                    $scope.queryTaxInfo();
                });
        };
        $scope.$watch('selectedList.length', () => {
            if (!$scope.selectedList.length) {
                $scope.queryParam.param.diskIdList = []
            }else {
                $scope.queryParam.param.diskIdList = $scope.selectedList.map((ele) => {
                    return ele.diskId
                })
            }
            downloadUrl = 'ems/sysTaxDisk/exportUkeyInfo?'
            Object.keys($scope.queryParam.param).forEach((key) => {
                downloadUrl += `${key}=${encodeURI($scope.queryParam.param[key])}&`
            })
            console.log(downloadUrl)
        })
        // 导出
        $scope.exportTaxClass = function exportTaxClass() {
            window.open(`${host.etcloud}${downloadUrl}&accessToken=${$scope.idToken}`)
        }
    }
}
taxControlCtrl.$inject = [
    '$scope',
    'httpRequest',
    '$state',
    'sweetalert',
    'logger',
    '$uibModal',
    'initSortService',
];



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxDisk/list.js